import React, { useState, useEffect } from 'react';

const MemoryRegeneration = () => {
  const [memories] = useState(JSON.parse(localStorage.getItem('memories') || '[]'));
  const [currentTest, setCurrentTest] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [score, setScore] = useState(0);

  const generateQuestion = (memory) => {
    const questionTypes = [
      `What happened in ${memory.location}?`,
      `When did this memory take place?`,
      `Can you describe the details of "${memory.title}"?`,
      `What feelings do you associate with this memory?`
    ];
    return questionTypes[Math.floor(Math.random() * questionTypes.length)];
  };

  const startTest = (memory) => {
    setCurrentTest({
      memory,
      question: generateQuestion(memory),
      originalText: memory.details
    });
    setUserAnswer('');
    setFeedback('');
  };

  const checkAnswer = () => {
    const similarity = compareSimilarity(userAnswer, currentTest.originalText);
    if (similarity > 0.5) {
      setScore(prev => prev + 1);
      setFeedback("Great recall! Your memory is strong.");
    } else {
      setFeedback(`Keep practicing! Here is the original memory: ${currentTest.originalText}`);
    }
  };

  // Simple similarity check (in real app, use more sophisticated NLP)
  const compareSimilarity = (answer, original) => {
    const words1 = answer.toLowerCase().split(' ');
    const words2 = original.toLowerCase().split(' ');
    const commonWords = words1.filter(word => words2.includes(word));
    return commonWords.length / words2.length;
  };

  return (
    <div className="memory-regeneration-container">
      <div className="memory-regeneration-intro">
        <h2>Memory Regeneration Training</h2>
        <p className="regeneration-description">
          Strengthen your memories through active recall exercises. Regular practice helps maintain 
          and improve memory function by stimulating neural pathways associated with your memories.
        </p>
        <div className="score-display">
          Current Score: {score}
        </div>
      </div>

      <div className="memory-exercise-grid">
        {!currentTest ? (
          memories.map(memory => (
            <div key={memory.id} className="memory-exercise-card" onClick={() => startTest(memory)}>
              <h3>{memory.title}</h3>
              <p className="exercise-prompt">Test your recall of this memory</p>
              <button className="start-exercise-btn">Start Exercise</button>
            </div>
          ))
        ) : (
          <div className="active-exercise-container">
            <h3>{currentTest.memory.title}</h3>
            <p className="exercise-question">{currentTest.question}</p>
            <textarea
              className="exercise-input"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Write your answer here..."
              rows={6}
            />
            <div className="exercise-controls">
              <button className="check-answer-btn" onClick={checkAnswer}>
                Check Recall
              </button>
              <button className="new-exercise-btn" onClick={() => setCurrentTest(null)}>
                Try Another Memory
              </button>
            </div>
            {feedback && <p className="exercise-feedback">{feedback}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default MemoryRegeneration; 